import styled from 'styled-components';
import { TitleLightWithSelectedParent } from '@warehouse/title/core';
import { CustomDataGridPro } from '../../../shared/ui/table/CustomDataGridPro';

export const StyledDataGrid = styled(CustomDataGridPro<TitleLightWithSelectedParent>)`
	.editable-cell {
		border-radius: 8px;

		&:focus,
		&:focus-within {
			border: 1px solid ${({ theme }) => theme.palette.blue.main} !important;
			outline: none;
		}
	}

	/* Remove focus styling from all regular cells */
	.MuiDataGrid-cell:focus,
	.MuiDataGrid-cell:focus-within,
	.MuiDataGrid-cell:focus-visible {
		outline: none !important;
		border: none !important;
	}

	/* Remove click/selection styling from cells */
	.MuiDataGrid-cell.Mui-selected,
	.MuiDataGrid-cell--selectable {
		background-color: inherit !important;
	}

	.MuiDataGrid-columnHeader {
		color: rgba(0, 0, 0, 0.8);
		font-size: 12px;
		font-weight: 500;
		text-transform: uppercase;
		height: 50px !important;
		padding: 0 12px !important;
	}

	.no-padding-cell {
		padding: 0px !important;
	}

	.padding-cell {
		padding-left: 20px !important;
	}

	.MuiDataGrid-main {
		.MuiDataGrid-virtualScroller {
			min-height: unset !important;
		}

		.MuiDataGrid-row {
			height: 50px !important;
			max-height: 50px !important;
			min-height: 50px !important;

			line-height: 50px !important;
		}

		.MuiDataGrid-cell {
			height: 50px !important;
			max-height: 50px !important;
			min-height: 50px !important;

			padding-top: 0 !important;
			padding-bottom: 0 !important;
			line-height: 50px !important;
		}

		.MuiDataGrid-row:hover {
			border-radius: 8px !important;
			overflow: hidden;
			.editable-cell {
				border: 1px solid ${({ theme }) => theme.palette.blue.main};
			}
			.MuiDataGrid-cell {
				background-color: rgb(211, 234, 253) !important;

				&:first-of-type {
					border-bottom-left-radius: 8px;
					border-top-left-radius: 8px;
				}

				&:last-of-type {
					border-bottom-right-radius: 8px;
					border-top-right-radius: 8px;
				}
			}

			.child-table-title-cell {
				border: solid 1px ${({ theme }) => theme.palette.blue.main};
			}
		}

		/* Keep border on editable cell when input is focused, even if not hovering */
		.editable-cell:focus-within {
			border: 1px solid ${({ theme }) => theme.palette.blue.main} !important;
		}
	}

	.MuiDataGrid-virtualScrollerContent {
		min-height: unset !important;
	}

	.MuiDataGrid-virtualScroller {
		border: 1px solid rgb(221, 224, 227);
		border-radius: 8px;
		height: auto !important;
		flex-grow: unset;
	}

	.MuiDataGrid-virtualScrollerRenderZone {
		position: relative !important;
	}

	.child-table-container {
		background: red !important;
	}
`;
